import {Power3} from "gsap";
import {AnimationEffects} from "../components/ShakeEffect";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TheCrypt} from "../TheCrypt";
import {TimelineLite, TweenLite} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class TheCryptGameView extends PIXI.Container implements StageLayer{
    private _dimmer: PIXI.Sprite;
    constructor() {
        super();
        this.name = "GameView";
        this.init();
    }

    private creatDimmer(): void {
        this._dimmer = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._dimmer.name = "dimmer";
        this._dimmer.tint = 0x000000;
        this._dimmer.alpha = 0.7;
        this._dimmer.visible = false;
    }

    private init() {
        this.position.set(0,0);
        this.creatDimmer();
    }

    public onWildNudge(): void {
        AnimationEffects.Shake({
            obj:this,
            duration: 1,
            hertz:120,
            x:1,
            y:1,
            Intensity:5,
            positionCb: () => new PIXI.Point(0,0),
            ease: Power3.easeOut,
            reverseEase:true
        })
    }

    public onNearWin(): void {
        AnimationEffects.Shake({
            obj:this,
            duration: 1,
            hertz:160,
            x:1,
            y:1,
            Intensity:4,
            positionCb: () => new PIXI.Point(0,0),
            ease: Power3.easeOut,
            reverseEase:true
        })
    }

    public onResize() {
        TheCrypt.collectors.onResize();
        TheCrypt.background.onResize();
        if(this._dimmer.visible){
            this.resetDimmer();
        }
    }

    private resetDimmer():void{
        const bonds = NolimitApplication.screenBounds
        this._dimmer.width = bonds.width;
        this._dimmer.height = bonds.height;
        this._dimmer.position.x = bonds.left;
        this._dimmer.position.y = bonds.top;
    }

    public addDimmer(aboveCollector:boolean = false, duration:number = 0.2): TimelineLite {
        return new TimelineLite().add(() => {
            if(aboveCollector){
                TheCrypt.fullScreenDimmer.addChild(this._dimmer);
            }else{
                TheCrypt.emptyLayerBelowCollector.addChild(this._dimmer);
            }
            this.resetDimmer();
            this._dimmer.alpha = 0;
            this._dimmer.visible = true;
        }).add(TweenLite.to(this._dimmer, duration, {alpha: 0.7}));
    }

    public removeDimmer(): TimelineLite {
        return new TimelineLite().to(this._dimmer, 0.2, {alpha: 0}).add(() => {
            if(this._dimmer.parent){
                this._dimmer.parent.removeChild(this._dimmer);
            }
            this._dimmer.visible = false;
        });
    }

}